import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-0f97d441"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "course-img"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "img-cover"
};
const _hoisted_4 = {
  class: "course-tag"
};
const _hoisted_5 = {
  key: 0,
  class: "tag"
};
const _hoisted_6 = {
  class: "num"
};
const _hoisted_7 = {
  class: "course-title"
};
const _hoisted_8 = {
  class: "title"
};
const _hoisted_9 = {
  class: "time"
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "所属教研室：", -1));

const _hoisted_11 = {
  class: "bottom"
};
const _hoisted_12 = {
  class: "left"
};
const _hoisted_13 = {
  class: "avatar-list"
};
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  key: 0
};

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "等", -1));

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "名教师", -1));

const _hoisted_18 = {
  key: 1
};
const _hoisted_19 = {
  key: 0,
  class: "right"
};

const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-diandian"
}, null, -1));

const _hoisted_21 = /*#__PURE__*/_createTextVNode("删除");

import DelDialog from './DelDialog';
import { getUrlParams, getCookie, handleLogin } from '@/plugins/utils';
export default {
  props: {
    courseData: Object,
    showDel: {
      type: Boolean,
      default: true
    },
    widthStyle: {
      type: Object,
      default: {
        width: '294px'
      }
    },
    type: {
      type: Number,
      default: 1 // 1 课程建设 2 优秀教研课程列表卡片 3 教研中心-全部课程 4 首页

    },
    menuInfo: Object
  },
  emits: ['updateCourseList'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const $utils = inject('$utils');
    const $http = inject('$http');
    const showDelDialog = ref(false); // const delId = ref('')

    const delCourse = data => {
      // delId.value = data.id
      ElMessageBox.confirm('<div class="tip-title">是否删除课程？</div><span class="tip-text">删除课程后将不可恢复</span>', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true
      }).then(async () => {
        const delRes = await $http.delMyCourse({
          id: data.id
        });

        if (delRes > 0) {
          emit('updateCourseList');
          ElMessage({
            type: 'success',
            message: '删除成功'
          });
        }
      }).catch(() => {});
    };

    const goCourseDetail = data => {
      // type 1 教研中心主页面的课程
      if (props.type == 2 || props.type == 4) {
        let menuId, menuName;

        if (props.type == 2) {
          menuId = getUrlParams('menuId');
          menuName = getUrlParams('name');

          if (!getCookie('X-Access-Token')) {
            // token不存在跳转登录
            handleLogin();
            return;
          }
        } else {
          console.log(props.menuInfo);
          menuId = props.menuInfo.menu_id;
          menuName = props.menuInfo.module_name;
        }

        const backInfo = {
          url: `/researchCourseList.html?menuId=${menuId}&name=${menuName}`,
          name: menuName
        };
        localStorage.setItem('backInfo', JSON.stringify(backInfo));
        window.location.href = `/courseDetailFront.html?courseId=${data.id}&menuId=${menuId}&enter_type=preview`;
      } else {
        const backInfo = {
          url: `${window.location.href}`,
          name: props.type == 1 ? '课程建设' : '全部课程'
        };
        localStorage.setItem('backInfo', JSON.stringify(backInfo));
        window.location.href = `/courseDetail.html?courseId=${data.id}`;
      }
    };

    return (_ctx, _cache) => {
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

      const _component_el_dropdown = _resolveComponent("el-dropdown");

      return _openBlock(), _createElementBlock("div", {
        class: "list-item",
        style: _normalizeStyle(__props.widthStyle)
      }, [_createElementVNode("div", {
        class: "top",
        onClick: _cache[0] || (_cache[0] = $event => goCourseDetail(__props.courseData))
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
        src: __props.courseData.file_url || require('@/assets/images/teachCenter/course_cover.png'),
        alt: ""
      }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [__props.courseData.classify_name ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(__props.courseData.classify_name), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, _toDisplayString(__props.courseData.plan_count) + "个教案", 1)])])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(__props.courseData.course_name), 1), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("span", null, _toDisplayString(__props.courseData.group_name), 1)])])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.courseData.terms.slice(0, 2), (item, index) => {
        return _openBlock(), _createElementBlock("img", {
          src: item.fileUrl || require('@/assets/images/common/teacher_icon.png'),
          key: index
        }, null, 8, _hoisted_14);
      }), 128))]), __props.courseData.terms.length > 2 ? (_openBlock(), _createElementBlock("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.courseData.terms.slice(0, 2), (item, index) => {
        return _openBlock(), _createElementBlock("span", {
          key: index
        }, [_createTextVNode(_toDisplayString(item.teacherName) + " ", 1), _withDirectives(_createElementVNode("span", null, "、", 512), [[_vShow, index == 0]])]);
      }), 128)), _hoisted_16, _createElementVNode("span", null, _toDisplayString(__props.courseData.terms.length), 1), _hoisted_17])) : _createCommentVNode("", true), __props.courseData.terms.length <= 2 ? (_openBlock(), _createElementBlock("div", _hoisted_18, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.courseData.terms, (item, index) => {
        return _openBlock(), _createElementBlock("span", null, [_createTextVNode(_toDisplayString(item.teacherName) + " ", 1), _withDirectives(_createElementVNode("span", null, "、", 512), [[_vShow, __props.courseData.terms.length == 2 && index == 0]])]);
      }), 256))])) : _createCommentVNode("", true)]), __props.showDel ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createVNode(_component_el_dropdown, {
        onCommand: delCourse
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
            command: {
              id: __props.courseData.id
            }
          }, {
            default: _withCtx(() => [_hoisted_21]),
            _: 1
          }, 8, ["command"])]),
          _: 1
        })]),
        default: _withCtx(() => [_hoisted_20]),
        _: 1
      })])) : _createCommentVNode("", true)])], 4);
    };
  }

};